import React from "react";
import KnowledgeBackedProfileChapter from "./KnowledgeBackedProfileChapter";

// Watch For-specific classification, grouping, and copy stay in
// watchForDomain.js. Shared Profile lifecycle stays in the reusable shell.
const ProfileWatchForChapter = (props) => (
  <KnowledgeBackedProfileChapter {...props} presentationMode="profileItems" showGroupHeadings />
);

export default ProfileWatchForChapter;
